module.exports = __webpack_public_path__ + "img/games-21.56d65d85.webp";